import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectDreamTeamCardData_MLB } from '../../../../store/showcase/showcase.selector';

// styles
import {
    CardDisplayContainer,
    ImgContainer,
    PositionContainer,
} from './CardDisplay.styles';

// assets
import pullVaultIcon from '../../../../assets/system/cardvault-symbol.png';
import closeIcon from '../../../../assets/system/icons/close-icon.svg';

// components
import CardAttribute from '../../../../components/card-attribute/CardAttribute';
import RevealImage from '../../../../components/reveal-image/RevealImage';

export default function CardDisplay({ id, isActive, positionLabel, onClick, onDeselect, enableHoverScale = true }) {
    const dreamTeamCardData_MLB = useSelector(selectDreamTeamCardData_MLB);

    const cardData = dreamTeamCardData_MLB?.[id] || null;
    const hasImage = !!cardData?.imageURL;

    return (
        <CardDisplayContainer
            onClick={isActive ? onDeselect : onClick}
            whileHover={enableHoverScale ? { scale: 1.05 } : undefined}
            transition={enableHoverScale ? { type: "spring", stiffness: 240, damping: 20 } : undefined}
        >
            <ImgContainer
                $isActive={isActive}
                $hasAssignedCard={!!cardData}
                $hasUploadedImage={!!cardData?.imageURL}
                $imageOrientation={cardData?.imageOrientation || "vertical"}
            >
                {isActive ? (
                    <img src={closeIcon} alt="deselect" style={{ height: '20px', width: 'auto', opacity: 1 }} />
                ) : hasImage ? (
                    <RevealImage
                        src={cardData.imageURL}
                        alt="card"
                        style={{ height: '100%', width: '100%' }}
                    />
                ) : cardData ? (
                    <img
                        src={pullVaultIcon}
                        alt="Card has nothing to show"
                    />
                ) : null}
            </ImgContainer>
            <PositionContainer>
                <CardAttribute text={positionLabel} />
            </PositionContainer>
        </CardDisplayContainer>
    );
}

CardDisplay.propTypes = {
    id: PropTypes.string.isRequired,
    positionLabel: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onDeselect: PropTypes.func,
    enableHoverScale: PropTypes.bool,
};